/**
 * Module definition and dependencies
 */
angular.module('App.Admin.Attribution', [
    'App.Admin.Attribution.Controller',
]);
